import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'

@Component({
  selector: 'app-tag-rating',
  templateUrl: './tag-rating.component.html',
  styleUrls: ['./tag-rating.component.css']
})
export class TagRatingComponent implements OnInit {
  @Input() dbRecord: DbRecord;
  @Input() id: string
  @Input() label: string
  @Input() ratingType: string
  @Input() state: string

  constructor() { }

  ngOnInit() {

  }

  click() {
    this.dbRecord.project.ratingChange(this.dbRecord,
      this.ratingType,
      this.state,
      this.id)
  }

  get currentState() {
    return this.dbRecord.project.currentRatingState(this.dbRecord,
      this.ratingType, this.id)
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag-rating/tag-rating.component.ts